// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Copyright (c) 2026 Miskulin Technologies. All rights reserved.
// ================================================================
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://rmoxuodrbhesecbxiwtz.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJtb3h1b2RyYmhlc2VjYnhpd3R6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk5Njg4NzgsImV4cCI6MjA4NTU0NDg3OH0.YGw29aX2_7s3KWIs0vI8_tSAJAos7Sxnp0tfS7bLOjc';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
